import React from 'react';
import { useFormContext } from 'react-hook-form';
import { InfoIcon } from 'lucide-react';
const ClientInformation = () => {
  const {
    register,
    formState: {
      errors
    },
    watch
  } = useFormContext();
  const existingClient = watch('clientInfo.existingClient');
  return <div className="space-y-8" data-id="element-542" data-mp="3w20at74lzt32">
      {/* Introductory Statement */}
      <div className="bg-amber-50 p-5 rounded-lg border border-amber-200 mb-6" data-id="element-543" data-mp="3w44m4a4u7udd">
        <p className="text-amber-900 leading-relaxed" data-id="element-544" data-mp="4v77nxq99jvw">
          The purpose of this questionnaire is to provide us with sufficient
          information to assist you in planning your estate and to get you
          thinking about certain aspects of your estate planning matters. This
          questionnaire does not replace the need for us to meet to discuss your
          estate planning in detail; this is only for discussion purposes at our
          meeting and to assist us in drafting your documents.
        </p>
      </div>

      <div className="space-y-6" data-id="element-545" data-mp="2koo9b2wbnmk2">
        {/* Existing Client */}
        <div data-id="element-546" data-mp="1je07brl1d5uh">
          <div className="flex items-center mb-2" data-id="element-547" data-mp="1jejqfbmfa0a3">
            <label className="text-navy-800 font-medium" data-id="element-548" data-mp="1elgsyseiy6om">
              Are you an existing client?
            </label>
          </div>
          <div className="flex items-center space-x-4 mb-4" data-id="element-549" data-mp="19mx7su7r8yxb">
            <label className="inline-flex items-center" data-id="element-550" data-mp="14oc7kusi6f8v">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="true" {...register('clientInfo.existingClient')} data-id="element-551" data-mp="14lpy2pm1xpo0" />
              <span className="ml-2" data-id="element-552" data-mp="1sd58l5nzfdac">Yes</span>
            </label>
            <label className="inline-flex items-center" data-id="element-553" data-mp="1sbalplt5hb3m">
              <input type="radio" className="form-radio h-5 w-5 text-navy-600" value="false" {...register('clientInfo.existingClient')} data-id="element-554" data-mp="1netu2hmqsels" />
              <span className="ml-2" data-id="element-555" data-mp="by3xlq84f15d">No</span>
            </label>
          </div>

          {/* Which lawyer - shown if existing client */}
          {existingClient === 'true' && <div className="mt-4" data-id="element-556" data-mp="346pd742yeqwk">
              <label className="block text-navy-800 font-medium mb-2" data-id="element-557" data-mp="345mmaw5msogn">
                Which lawyer have you worked with?
                <span className="text-red-500 ml-1" data-id="element-558" data-mp="2q90ofl5rmzm8">*</span>
              </label>
              <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter the lawyer's name" {...register('clientInfo.existingLawyer')} data-id="element-559" data-mp="2v3wn345icl8b" />
            </div>}
        </div>

        {/* How did you hear about us - Changed to text box */}
        <div data-id="element-560" data-mp="2ccvkm656i7k0">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-561" data-mp="1xi8zn8r15d8x">
            How did you hear about us?
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Please describe how you heard about our firm" {...register('clientInfo.referralSource')} data-id="element-562" data-mp="22hbu5z9dw12n" />
        </div>

        {/* Full Legal Name */}
        <div data-id="element-563" data-mp="1sr3j6sq8u49v">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-564" data-mp="1nud52ay01ir3">
            Full Legal Name
            <span className="text-red-500 ml-1" data-id="element-565" data-mp="21u4nqozgnnbf">*</span>
          </label>
          <input type="text" className={`w-full px-3 py-2 border ${errors.clientInfo?.fullName ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="Enter your full legal name" {...register('clientInfo.fullName')} data-id="element-566" data-mp="21sbdkzpn2kyo" />
          {errors.clientInfo?.fullName && <p className="text-red-500 text-sm mt-1" data-id="element-567" data-mp="2lin6anpyo2h5">
              {errors.clientInfo.fullName.message as string}
            </p>}
          <p className="text-slate-500 text-sm mt-1" data-id="element-568" data-mp="dwdcq8mogsjt">
            Please provide your full legal name as it appears on official
            documents.
          </p>
        </div>

        {/* Age */}
        <div data-id="element-569" data-mp="nm6md439exlf">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-570" data-mp="nln6dsx66ja1">
            Age
            <span className="text-red-500 ml-1" data-id="element-571" data-mp="sl9rspn5j5tx">*</span>
          </label>
          <input type="number" className={`w-full px-3 py-2 border ${errors.clientInfo?.age ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="Enter your age" {...register('clientInfo.age')} data-id="element-572" data-mp="sncht9ob0yyn" />
          {errors.clientInfo?.age && <p className="text-red-500 text-sm mt-1" data-id="element-573" data-mp="9vtfl523toxo">
              {errors.clientInfo.age.message as string}
            </p>}
        </div>

        {/* Marital Status */}
        <div data-id="element-574" data-mp="1l9fe3gtut2vv">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-575" data-mp="1l8vy45nrkokh">
            Marital Status
            <span className="text-red-500 ml-1" data-id="element-576" data-mp="35s98k7ahuj2m">*</span>
          </label>
          <select className={`w-full px-3 py-2 border ${errors.clientInfo?.maritalStatus ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} {...register('clientInfo.maritalStatus')} data-id="element-577" data-mp="30t4y7dbu2fap">
            <option value="" data-id="element-578" data-mp="2r0z6m4phtzw1">Please select</option>
            <option value="married" data-id="element-579" data-mp="2m48pde1ycy91">Married</option>
            <option value="commonLaw" data-id="element-580" data-mp="2m1nnip1nmiba">Common Law</option>
            <option value="divorced" data-id="element-581" data-mp="2i1lvl7lq1397">Divorced</option>
            <option value="widowed" data-id="element-582" data-mp="2d3amx075wysk">Widowed</option>
            <option value="single" data-id="element-583" data-mp="2d43n1ibm8q1q">Single</option>
          </select>
          {errors.clientInfo?.maritalStatus && <p className="text-red-500 text-sm mt-1" data-id="element-584" data-mp="28624qzm0kurb">
              {errors.clientInfo.maritalStatus.message as string}
            </p>}
        </div>

        {/* Address */}
        <div data-id="element-585" data-mp="6ddtc2z7v10g">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-586" data-mp="6aro49zssxle">
            Address
            <span className="text-red-500 ml-1" data-id="element-587" data-mp="20rhw1ywulktf">*</span>
          </label>
          <textarea className={`w-full px-3 py-2 border ${errors.clientInfo?.address ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} rows={3} placeholder="Enter your current address" {...register('clientInfo.address')} data-id="element-588" data-mp="25kulgb9cpvn8" />
          {errors.clientInfo?.address && <p className="text-red-500 text-sm mt-1" data-id="element-589" data-mp="2oj6w61fwvdkx">
              {errors.clientInfo.address.message as string}
            </p>}
        </div>

        {/* Phone Number */}
        <div data-id="element-590" data-mp="2ek7lyefhz9vt">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-591" data-mp="2ejy3rd0p270o">
            Phone Number
            <span className="text-red-500 ml-1" data-id="element-592" data-mp="y5pw0okl2293">*</span>
          </label>
          <input type="tel" className={`w-full px-3 py-2 border ${errors.clientInfo?.phone ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="(123) 456-7890" {...register('clientInfo.phone')} data-id="element-593" data-mp="y8ke49g4jazc" />
          {errors.clientInfo?.phone && <p className="text-red-500 text-sm mt-1" data-id="element-594" data-mp="3qcgm0at79bpv">
              {errors.clientInfo.phone.message as string}
            </p>}
        </div>

        {/* Email */}
        <div data-id="element-595" data-mp="2ylsr3gi4d2kn">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-596" data-mp="2yndkh2sp6fgx">
            Email
            <span className="text-red-500 ml-1" data-id="element-597" data-mp="2toagllogefaj">*</span>
          </label>
          <input type="email" className={`w-full px-3 py-2 border ${errors.clientInfo?.email ? 'border-red-500' : 'border-slate-300'} rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500`} placeholder="your.email@example.com" {...register('clientInfo.email')} data-id="element-598" data-mp="37enltg9ynfw6" />
          {errors.clientInfo?.email && <p className="text-red-500 text-sm mt-1" data-id="element-599" data-mp="2aux0untbaffi">
              {errors.clientInfo.email.message as string}
            </p>}
          <p className="text-slate-500 text-sm mt-1" data-id="element-600" data-mp="34qddkny0c2z3">
            We'll use this email to communicate with you about your documents.
          </p>
        </div>

        {/* Employment Information Section */}
        <div className="pt-4" data-id="element-601" data-mp="3drtn6th00129">
          <div className="flex items-center mb-2" data-id="element-602" data-mp="3dt4ommmz0wq7">
            <h3 className="text-lg font-medium text-navy-900" data-id="element-603" data-mp="3ir6affbs7a5d">
              Employment Information
            </h3>
            <span className="text-red-500 ml-1" data-id="element-604" data-mp="3noy4aevzl6c7">*</span>
            <div className="ml-2 group relative" data-id="element-605" data-mp="3nnekieb4gd5o">
              <InfoIcon size={16} className="text-slate-500 cursor-help" data-id="element-606" data-mp="3shiuz7jlj3bi" />
              <div className="absolute left-0 bottom-full mb-2 hidden group-hover:block bg-navy-800 text-white text-xs p-3 rounded w-72 z-10" data-id="element-607" data-mp="d6qufjwqmhv">
                We are required to collect this information as part of 'Know
                Your Client' rules under professional regulatory requirements.
              </div>
            </div>
          </div>
          <div className="bg-blue-50 p-3 rounded-md border border-blue-200 mb-4" data-id="element-608" data-mp="kg305ijvzoyc">
            <p className="text-sm text-blue-800" data-id="element-609" data-mp="fe3ug20ocfy8">
              <strong data-id="element-610" data-mp="agc2x93xyvuk">Required:</strong> We are required to collect this
              information as part of 'Know Your Client' rules under professional
              regulatory requirements.
            </p>
          </div>

          {/* Occupation */}
          <div className="mb-4" data-id="element-611" data-mp="134rhxvn2pe5w">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-612" data-mp="y66fdpkcmiea">
              Occupation
              <span className="text-red-500 ml-1" data-id="element-613" data-mp="y8iwy1m72qqt">*</span>
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your occupation" {...register('clientInfo.occupation')} data-id="element-614" data-mp="tdn3qy581xc4" />
          </div>

          {/* Employer Name */}
          <div className="mb-4" data-id="element-615" data-mp="2if9crc5u4psp">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-616" data-mp="2igc3nk35qs8m">
              Employer Name
              <span className="text-red-500 ml-1" data-id="element-617" data-mp="2dhhkgh1a31nz">*</span>
            </label>
            <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="Enter your employer's name" {...register('clientInfo.employerName')} data-id="element-618" data-mp="2rgqsuuj8srhe" />
          </div>

          {/* Business Address */}
          <div className="mb-4" data-id="element-619" data-mp="2wf23v8l9x817">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-620" data-mp="3a6gxsagpytn1">
              Business Address
              <span className="text-red-500 ml-1" data-id="element-621" data-mp="365dibp2l2zmc">*</span>
            </label>
            <textarea className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" rows={3} placeholder="Enter your business address" {...register('clientInfo.businessAddress')} data-id="element-622" data-mp="367hj3y56riie" />
          </div>

          {/* Business Phone */}
          <div className="mb-4" data-id="element-623" data-mp="7k94hshqdojb">
            <label className="block text-navy-800 font-medium mb-2" data-id="element-624" data-mp="7j7rhih5mryy">
              Business Phone
              <span className="text-red-500 ml-1" data-id="element-625" data-mp="3ovi9s9xymoz3">*</span>
            </label>
            <input type="tel" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="(123) 456-7890" {...register('clientInfo.businessPhone')} data-id="element-626" data-mp="3tr7fyw4hj44d" />
          </div>
        </div>

        {/* Citizenship */}
        <div data-id="element-627" data-mp="3b20resh0fian">
          <label className="block text-navy-800 font-medium mb-2" data-id="element-628" data-mp="3b1hj83h5w89t">
            Citizenship(s)
          </label>
          <input type="text" className="w-full px-3 py-2 border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-navy-500" placeholder="e.g., Canadian, American" {...register('clientInfo.citizenship')} data-id="element-629" data-mp="2x1zo76d9vys0" />
          <p className="text-slate-500 text-sm mt-1" data-id="element-630" data-mp="12unpfop59tcv">
            Please list all countries of citizenship. This information is
            important for tax and estate planning purposes.
          </p>
        </div>
      </div>
    </div>;
};
export default ClientInformation;